import { Box, Stack } from '@mui/material';

// eslint-disable-next-line @nx/enforce-module-boundaries
import { Divider, LoadingOverlay, Paper, Typography } from '@occc-app/design-system';

import { membershipReferralInfoMessages } from './membership-referral-info.messages';

type MembershipReferralInfoProps = {
  totalReferrals: number;
  referralCode: string;
  isLoading: boolean;
};

export const MembershipReferralInfo = (props: MembershipReferralInfoProps) => {
  const { totalReferrals, referralCode, isLoading } = props;
  return (
    <Stack
      component={Paper}
      divider={<Divider orientation='vertical' flexItem />}
      direction='row'
      spacing={2}
      p={2}
      position='relative'
      overflow='hidden'
    >
      <Box flex={1} textAlign='center'>
        <Typography variant='h5'>{totalReferrals}</Typography>
        <Typography variant='caption' color='textSecondary'>
          {membershipReferralInfoMessages.totalReferralsLabel}
        </Typography>
      </Box>
      <Box flex={1} textAlign='center'>
        <Typography variant='h5'>{referralCode}</Typography>
        <Typography variant='caption' color='textSecondary'>
          {membershipReferralInfoMessages.referralCodeLabel}
        </Typography>
      </Box>
      {isLoading && <LoadingOverlay loaderSize={32} />}
    </Stack>
  );
};
